import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpUtils } from '../../../../../../common/http/http-utils';

@Injectable()
export class Service {
  value = '';

  constructor(public http: HttpClient) {
  }

  runOutOfPlaceRestore(vcId, obj) {
    let url = HttpUtils.getBaseUrl() + '/hybridity/api/dps/vc/' + vcId + '/vm/restore';
    return this.http
      .post(url, JSON.stringify(obj))
      .map(
        (res:any) => this.value = res
      );
  }

  getRestoreTargetDatastores(vcId, entityType, entity_id) {
    let url = HttpUtils.getBaseUrl() + '/hybridity/api/dps/vc/' + vcId + '/datastores?entityType=' + entityType + '&entity_id=' + entity_id;
    return this.http
      .get(url)
      .map(
        (res:any) => this.value = res
      );
  }

  nodes = [];
  getTreeNodes(url) {
        return this.http.get(HttpUtils.getBaseUrl() + url).map((res:any) => this.nodes = res);
  }

  getChildNodes(url) {
      return this.http.get(HttpUtils.getBaseUrl() + url).toPromise();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vc/common-ops/out-of-place-restore/out-of-place-restore.service.ts